import React, {Component} from 'react'
import {Button, Form, Grid, Segment,} from 'semantic-ui-react'
import PropTypes from 'prop-types'
import {WarningMessage} from "../utils_components.jsx";
import {ItemField} from "./item_field.jsx";

export const FORM_STYLE = {
        position: 'relative',
        background: '#fff',
        padding: '20px',
        paddingBottom: '80px',
        boxShadow: '0 8px 32px #aaa',
    }
;

export class Item extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false
        };
        this.refItem = React.createRef()
    }

    handleAddition = (fieldIndex, value) => {
    };

    shouldComponentUpdate(nextProps, nextState) {
        return (
            this.props.item !== nextProps.item ||
            this.props.applyToAll !== nextProps.applyToAll ||
            this.props.showApplyToAll !== nextProps.showApplyToAll ||
            this.props.loopIndex !== nextProps.loopIndex ||
            this.props.loopType !== nextProps.loopType ||
            this.props.isObserver !== nextProps.isObserver ||
            this.props.values !== nextProps.values ||
            this.props.preliminaries !== nextProps.preliminaries ||
            this.props.hasErrors !== nextProps.hasErrors ||
            this.props.preliminarySection !== nextProps.preliminarySection ||
            this.state !== nextState);
    }

    scroll() {
        const current = this.refItem.current;
        if (current) {
            const yOffset = -100;
            const y = this.refItem.current.getBoundingClientRect().top + window.pageYOffset + yOffset;
            window.scrollTo({top: y, behavior: 'smooth'});
        }
    }

    checkMissing() {
        const {values, item} = this.props;
        let newValues;
        if (!values) {
            newValues = item.fields !== undefined ? Array(item.fields.length) : Array();
        } else {
            newValues = values;
        }
        if (item.fields === undefined) {
            return false;
        }
        for (let i = 0; i < item.fields.length; i++) {
            if (!item.fields[i].optional && item.fields[i].type !== 'noInput' && item.fields[i].type !== 'checkbox') {
                if (newValues === undefined || newValues[i] === undefined || newValues[i] === null) {
                    return true;
                }
            }
        }
        return false;
    }

    submit() {
        // this.scroll();
        this.props.onSubmit();
    }

    render() {
        const {
            showApplyToAll,
            applyToAll,
            preliminarySection,
            values,
            preliminaries,
            item,
            loopIndex,
            isObserver,
            readOnly,
            onApplyToAll,
            loopType
        } = this.props;
        let newValues, newPreliminaries;
        if (!values) {
            newValues = item.fields !== undefined ? Array(item.fields.length) : Array();
        } else {
            newValues = values;
        }
        if (!preliminaries) {
            newPreliminaries = item.fields !== undefined ? Array(item.fields.length) : Array();
        } else {
            newPreliminaries = preliminaries;
        }
        const fields = item.fields;
        const missingValues = !readOnly && this.checkMissing();
        const hasErrors = item.errors.length > 0;
        let itemKey = "item" + item.id + "-";
        if (item.loopName && loopIndex !== undefined) {
            itemKey += item.loopName + "-" + loopIndex + "-";
        }
        const globalErrors = [];
        const fieldErrors = fields !== undefined ? Array(fields.length) : Array();
        for (let i = 0; i < item.errors.length; i++) {
            const error = item.errors[i];
            if (error.field === undefined) {
                globalErrors.push(error)
            } else {
                fieldErrors[i] = error
            }
        }

        let handleChange, handleAddition, togglePreliminary;
        if (readOnly) {
            handleChange = (fieldIndex, value) => null;
            handleAddition = (value) => null;
            togglePreliminary = (fieldIndex) => null;
        } else {
            handleChange = (fieldIndex, value) => this.props.onChange(fieldIndex, value);
            handleAddition = (fieldIndex, value) => this.handleAddition(fieldIndex, value);
            togglePreliminary = (fieldIndex) => {
                const preliminary = !newPreliminaries[fieldIndex]
                this.props.onItemPreliminaryChange(fieldIndex, preliminary);
            }
        }
        const actionableFields = fields.filter(field => field.type !== 'noInput');
        const applyToAllText = 'apply those responses to all ' + loopType;
        return (
            <Form className={readOnly ? 'readOnly' : ''} style={FORM_STYLE}>

                <div ref={this.refItem} className={'background-orange'}>
                    <p className={"itemTitle"}>{item.title}</p>
                </div>
                {globalErrors.map((error, errorIndex) => {
                    return (
                        <WarningMessage key={"error-" + errorIndex} header="Inconsistent answers"
                                        message={error.text}/>)
                })}
                {!readOnly && fields.length > 0 &&
                <Button title={"next"} style={{paddingTop: '3px', paddingBottom: '3px', margin: 0}} compact basic
                        floated='right'
                        onClick={this.submit.bind(this)}
                        disabled={missingValues || hasErrors} icon='arrow right'/>
                }
                <Form.Group grouped>


                    {fields.map((field, fieldIndex) => <ItemField readOnly={readOnly}
                                                                  isObserver={isObserver}
                                                                  handleChange={(value) => handleChange(fieldIndex, value)}
                                                                  handleAddition={(value) => handleAddition(fieldIndex, value)}
                                                                  togglePreliminary={() => togglePreliminary(fieldIndex)}
                                                                  value={newValues[fieldIndex]}
                                                                  preliminary={newPreliminaries[fieldIndex]}
                                                                  preliminarySection={preliminarySection}
                                                                  error={fieldErrors[fieldIndex]}
                                                                  itemKey={itemKey + "-" + loopIndex}
                                                                  loopName={item.loopName}
                                                                  focused={fieldIndex === 0}
                                                                  key={itemKey + "-" + loopIndex + '-' + fieldIndex} {...field} />)}
                    {actionableFields.length > 0 && showApplyToAll && <>
                        <hr/>
                        <ItemField type="checkbox" handleChange={(value) => onApplyToAll(value)} label={applyToAllText}
                                   readOnly={readOnly} isObserver={isObserver}
                                   value={applyToAll}/>
                    </>}
                </Form.Group>
                {/*<Form.Group grouped>*/}
                {/*<Form.Input label={"What is your name?"} value={"test"} onChange={this.handleChange.bind(this)}/>*/}
                {/*</Form.Group>*/}
                <br/>
                {!readOnly && fields.length > 0 && <Grid centered>
                    <Button
                        onClick={this.submit.bind(this)} primary
                        disabled={missingValues || hasErrors}>Next</Button>
                </Grid>}
                <Segment basic textAlign='left' floated='left'><span
                    className={'mandatory-field-explanation'}>*</span>required
                    fields</Segment>
                <Segment style={{color: '#aaa'}} size='mini' basic textAlign='right'
                         floated='right'>{item.id}</Segment>
            </Form>


        )

    }


}

Item.propTypes = {
    item: PropTypes.object.isRequired,
    initialState: PropTypes.object,
    onSubmit: PropTypes.func.isRequired
};

